import React from "react";
import { StyleSheet, Text, TextInput, TouchableOpacity } from "react-native";
import Icons from "@expo/vector-icons/MaterialCommunityIcons";
import { View } from "../shared/Themed";
import { ReadOnlyProps } from "../../utils/templates";

interface Props {
  required?: boolean;
  title: string;
  placeholder?: string;
  value: string;
  width: string;
  editable?: boolean;
  blurOnSubmit?: boolean;
  isMultiline?: boolean;
  refInput?: any;
  height?: number;
  isTextEntrySecure?: boolean;
  showSoftInputOnFocus?: boolean;
  setChangeText: (event: any) => void;
  handleOnSubmitEditing?: (event: any) => void;
  autofocus?: boolean;
}

export const TextInputControlOrder: React.FC<ReadOnlyProps<Props>> = ({
  required = false,
  title,
  placeholder = "",
  value,
  width,
  editable = true,
  blurOnSubmit = true,
  isMultiline = false,
  isTextEntrySecure = false,
  showSoftInputOnFocus = true,
  refInput,
  height = 28,
  setChangeText,
  handleOnSubmitEditing,
  autofocus = false,
}: ReadOnlyProps<Props>) => {
  return (
    <View style={[styles.container, { width: width as any, marginBottom: 15 }]}>
      <View style={styles.row}>
        <View style={styles.labelContainer}>
          <Text style={[styles.label, { color: "black" }]}>
            {title}{" "}
            {!required && (
              <Text style={{ fontSize: 10, color: "lightgrey" }}>
                (Optional)
              </Text>
            )}
          </Text>
        </View>
        <View
          style={isMultiline ? styles.inputContainerMulti : styles.inputContainer}
        >
          <TextInput
            style={[styles.input, isMultiline && { height: height, textAlignVertical: 'top' }]}
            ref={refInput}
            onChangeText={setChangeText}
            placeholder={placeholder}
            value={value}
            multiline={isMultiline}
            editable={editable}
            blurOnSubmit={blurOnSubmit}
            autoFocus={autofocus}
            onSubmitEditing={handleOnSubmitEditing}
            secureTextEntry={isTextEntrySecure}
            showSoftInputOnFocus={showSoftInputOnFocus}
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    minHeight: 44,
  },
  labelContainer: {
    flex: 1,
    justifyContent: "center",
  },
  inputContainer: {
    flex: 1.75,
    paddingLeft: 15,
  },
  inputContainerMulti: {
    flex: 1.75,
    paddingLeft: 15,
  },
  label: {
    fontSize: 15,
    textAlign: "left",
    fontWeight: "400",
  },
  input: {
    borderWidth: 1,
    borderRadius: 4,
    paddingHorizontal: 12,
    paddingVertical: 8,
    fontSize: 14,
    borderColor: "#79747E",
    textAlign: "center",
    minHeight: 44,
  },
});
